import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Shield, Users, FileText, ToggleLeft, MessageSquare, Receipt, LayoutDashboard, BookOpen, ArrowLeft, Bug, Coins, Compass, Send } from "lucide-react";

const items = [
  { to: "/admin", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/admin/users", label: "Users", icon: Users },
  { to: "/admin/broadcast", label: "Broadcast email", icon: Send },
  { to: "/admin/cms", label: "Site copy", icon: FileText },
  { to: "/admin/resources", label: "Resources", icon: BookOpen },
  { to: "/admin/tools", label: "Tool flags", icon: ToggleLeft },
  { to: "/admin/tool-config", label: "Credits & access", icon: Coins },
  { to: "/admin/strategy-operator", label: "Strategy Operator", icon: Compass },
  { to: "/admin/messages", label: "Messages", icon: MessageSquare },
  { to: "/admin/bugs", label: "Bug reports", icon: Bug },
  { to: "/admin/transactions", label: "Transactions", icon: Receipt },
];

export default function AdminLayout() {
  const { user } = useAuth();
  const nav = useNavigate();
  if (!user?.is_admin) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC] px-4">
        <div className="dms-card p-8 max-w-md text-center">
          <Shield className="w-10 h-10 mx-auto text-[#1D4E89]" />
          <h1 className="mt-4 font-heading font-bold text-2xl text-[#0A2342]">Admin only</h1>
          <p className="mt-2 text-[#475569] text-[14.5px]">Your account is not an admin. Add your email to the ADMIN_EMAILS env var on the backend.</p>
          <button onClick={() => nav("/dashboard")} className="mt-6 dms-btn-primary w-full justify-center">Back to dashboard</button>
        </div>
      </div>
    );
  }
  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <header className="sticky top-0 z-30 bg-[#0A2342] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-14 flex items-center justify-between">
          <Link to="/admin" className="flex items-center gap-2.5">
            <Shield className="w-4 h-4 text-[#4FD1C5]" />
            <span className="font-heading font-bold text-[14px]">DMS Admin</span>
          </Link>
          <Link to="/dashboard" className="text-[12px] text-[#4FD1C5] hover:text-white inline-flex items-center gap-1.5">
            <ArrowLeft className="w-3.5 h-3.5" /> Back to app
          </Link>
        </div>
      </header>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 grid grid-cols-1 lg:grid-cols-12 gap-6">
        <aside className="lg:col-span-3">
          <nav className="dms-card p-2 sticky top-20">
            {items.map(({ to, label, icon: Icon, end }) => (
              <NavLink
                key={to} to={to} end={end} data-testid={`admin-nav-${label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) => `flex items-center gap-2.5 px-3 py-2.5 rounded-md text-[13.5px] transition ${
                  isActive ? "bg-[#0A2342] text-white" : "text-[#1F2937] hover:bg-[#F1F5F9]"
                }`}
              >
                <Icon className="w-4 h-4" />
                <span className="font-medium">{label}</span>
              </NavLink>
            ))}
          </nav>
        </aside>
        <main className="lg:col-span-9 min-w-0"><Outlet /></main>
      </div>
    </div>
  );
}
